<template>
  <div class="news_warp">
    <div class="news_container">
      <div class="title_icon">
        <div class="icon_box1"></div>
        <div class="icon_box2"></div>
        <h1>新闻通告</h1>
      </div>
      <div class="Xflex_box" style="margin-top: 30px;height: 90%;">
        <div class="leftBox">
          <div class="left_img">
            <div class="block">
              <el-carousel
                trigger="click"
                :interval="5000"
                @change="changeForNew"
                height="220px"
                :autoplay="false"
              >
                <el-carousel-item v-for="item in carouselList" :key="item.id">
                  <img
                    :src="item.image"
                    style="object-fit: cover"
                    width="412px"
                    height="220px"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="title" @click="toDetail(news)">
            {{ news.title }}
          </div>
          <p>{{ news.keyword }}</p>
          <h4>{{ news.note }}</h4>
        </div>
        <div class="centerBox">
          <div
            class="newsItem"
            v-for="item in newsList"
            :key="item.id"
            @click="toDetail(item)"
          >
            <div class="dateBox">
              <div class="date">{{ item.note ? item.note.slice(8) : "" }}</div>
              <div class="ym">{{ item.note ? item.note.slice(0, 7) : "" }}</div>
            </div>
            <div class="title">
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="more">
            <a
              class="moreBtn"
              href="javascript:void(0)"
              @click="goPage('/news')"
              >更多详情+</a
            >
          </div>
        </div>
        <div class="rightBox">
          <div class="img" @click="toLink('/subjectresources')">
            <img src="../../assets/学科资源.png" alt="学科资源" />
          </div>
          <!-- <div class="img" @click="toUrl">
            <img src="../../assets/校外访问.png" alt="校外访问" />
          </div> -->

          <div class="img" @click="toUrl">
            <img src="../../assets/阅读活动.png" alt="阅读活动" />
          </div>
          <div class="img" @click="toLink('/consult')">
            <img src="../../assets/咨询我们.png" alt="咨询我们" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post, get } from "@u/request";
export default {
  name: "",
  components: {},
  props: {
    copyright: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      news: {
        title: "2023年劳动节开放时间安排",
        content:
          "管理学院图书馆的前身是成立于1979年的管理科学系资料室，随着学院办学条件的改善和规模.....",
        date: "2023-04-30",
      },
      newsList: [],
      carouselList: [],
    };
  },
  methods: {
    toUrl() {
      window.open("https://fdsmlib.mh.chaoxing.com");
    },
    toLink(url) {
      this.$router.push(url);
    },
    toDetail(item) {
      if (item.linkUrl) {
        window.open(item.linkUrl);
      } else {
        this.$router.push(`/news/detail/${item.id}`);
      }
    },
    async loadList() {
      const params = {
        status: 1,
        pageNum: 1,
        pageSize: 7,
        menuId: 10023,
      };
      const { rows } = await get("lib/content/list", params).catch(() => {});
      const carouselList = [];
      const newsList = [];

      for (let index = 0; index < rows.length; index++) {
        const element = rows[index];
        if (index < 3) {
          carouselList.push(element);
        } else {
          newsList.push(element);
        }
      }
      if (carouselList.length > 0) {
        this.news = carouselList[0];
      }
      this.carouselList = carouselList;
      this.newsList = newsList;
    },
    changeForNew(curIndex) {
      const curNew = this.carouselList.find(
        (item, index) => index === curIndex
      );
      this.news = curNew;
    },
    goPage(url) {
      this.$router.push(url);
    },
  },
  created() {
    this.loadList();
  },
};
</script>

<style scoped lang="scss">
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.news_warp {
  background-color: #fff;
  margin-top: 130px;
  // margin-bottom: 130px;
  height: 600px;

  .news_container {
    width: 1400px;
    height: 100%;
        // padding: 20px 0 60px 0;
    padding: 20px 0px 60px 0px;
    margin: 0 auto;
    .leftBox {
      width: 33%;
      height: 100%;
      padding: 25px;
      background-color: #f5f5f5;
      .left_img {
        img {
          height: 100%;
          width: 100%;
        }
      }
      .title {
        margin: 20px 0 10px;
        font-weight: 700;
        font-size: 17px;
        cursor: pointer;
      }
      p {
        font-size: 13px;
        color: #757575;
      }
      h4 {
        margin-top: 10px;
        font-size: 12px;
        color: #c3c3c3;
      }
    }
    .centerBox {
      display: flex;
      // justify-content: space-between;
      flex-direction: column;
      width: 40%;
      height: 100%;
      .newsItem {
        display: flex;
        height: 21%;
        padding: 10px;
        background-color: #fff;
        .dateBox {
          height: 85%;
          width: 60px;
          color: #fff;
          background-color: #004796;
          text-align: center;
          .date {
            padding-top: 5px;
            font-size: 26px;
            line-height: 30px;
          }
          .ym {
            font-size: 12px;
          }
        }
        .title {
          display: table;
          width: 83%;
          padding-left: 20px;
          font-weight: 700;
          font-size: 17px;
          span {
            display: table-cell;
            vertical-align: middle;
          }
        }
      }
      .newsItem:hover {
        cursor: pointer;
        background-color: #f5f5f5;
      }
      .more {
        height: 16%;
        padding: 10px 0 0 10px;
        .moreBtn {
          display: inline-block;
          cursor: pointer;
          height: 50px;
          width: 140px;
          line-height: 46px;
          text-align: center;
          color: #f3aa63;
          border: 2px solid #f3aa63;
        }
        .moreBtn:hover {
          color: #fff;
          background-color: #f3aa63;
        }
      }
    }
    .rightBox {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      //width: 23%;
      height: 100%;
      .img {
        cursor: pointer;
        height: 136px;
        margin-bottom: 10px;
        img {
          height: 144px;
          width: 336px;
        }
      }
    }
  }
  ::v-deep {
    .el-carousel__item.is-active {
      z-index: 1 !important;
    }
  }
}
</style>
